import { Nullable } from '../../../foundation'

type ImageUrl = string

export interface ImageFileRepository {
  upload(files: File[], type?: string): Promise<Nullable<ImageUrl[]>>
}

export enum ImageContextTypes {
  HOSPITAL = 'HOSPITAL',
  COMMUNITY = 'COMMUNITY',
  REVIEW = 'REVIEW',
  SERVICE_OFFER = 'SERVICE_OFFER',
  ETC = 'ETC',
}

export enum FileTypes {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
}

export enum FileAccessTypes {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}
